/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VlcCardHeader.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";
import { vlcAppTheme } from "../config/vlcConfig";
import { componentStyle } from "../../../../config/appTheme";
import CustomToolTip from "../../../infoButton/CustomToolTip";
import RefreshIcon from "@mui/icons-material/Refresh";

function VlcCardHeader({
  children,
  title,
  showRecreateIcon = false,
  onRecreateClick = () => { },
  selectedEEComponentDetails,
  variantOptionList,
  selectedSingleVariantDetails,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography
          fontWeight={600}
          variant="subtitle1"
          sx={{
            ...componentStyle.font.text,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "70%",
            color: vlcAppTheme.vlcCardFontHeadingColor,
          }}
        >
          <CustomToolTip
            type="string"
            length={60}
            style={{
              ...componentStyle.font.text,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
            title={`${title}`}
          >
            {title}
          </CustomToolTip>
        </Typography>
        {selectedEEComponentDetails?.variant_ids?.length > 0 ? (
          <Box sx={{ display: "flex" }}>
            {variantOptionList

              ?.filter(
                (variant) =>
                  variant?.value !== selectedSingleVariantDetails?.variant_id &&
                  selectedEEComponentDetails?.variant_ids?.includes(
                    variant?.value,
                  ),
              )
              ?.map((colour) => {
                return (
                  <Box>
                    <CustomToolTip type="component" title={colour?.label}>
                      <Skeleton
                        animation={"false"}
                        variant="rectangular"
                        sx={{
                          backgroundColor: colour?.color,
                          marginTop: "2px",
                          marginLeft: "2px",
                          borderRadius: 0,
                          border:
                            colour?.color?.toLowerCase() === "#000000" ||
                              colour?.color?.toLowerCase() === "black"
                              ? "1px solid #ffffff"
                              : "none",
                        }}
                        width={12}
                        height={12}
                      />
                    </CustomToolTip>
                  </Box>
                );
              })}
          </Box>
        ) : null}
        {/* </Box> */}
        {showRecreateIcon && (
          <Box sx={{ cursor: "pointer" }} onClick={onRecreateClick}>
            <RefreshIcon />
          </Box>
        )}
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

export default VlcCardHeader;
